import { user } from "../../app.store";
import { get, writable } from 'svelte/store';
import { ChallengeService } from '../../services/challenge.service';
import { SectionService } from '../../services/section.service';
import { SubmissionService } from '../../services/submission.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const section = writable(null);
export const challenge = writable(null);
export const winning = writable([]);
export const records = writable([]);
export const pagination = writable(null);
export const sourceCode = writable("");
export const compilerId = writable(-1);
export async function initSectionAndChallenge(sectionId, challengeId) {
    fetchSection(sectionId);
    fetchChallenge(challengeId);
    if (get(compilerId) == null)
        loadMyDefaultCompiler();
}
export async function initSubmissionsList(sectionId, challengeId) {
    filter.set({ criteria: { challengeId: challengeId }, params: null, sorting: "-createdOn" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    // fetchSection(sectionId);
    // fetchChallenge(challengeId);
    loadWinningSubmissions(challengeId);
    loadUserSubmissions(challengeId);
}
export async function fetchSection(sectionId) {
    let _resp = await SectionService.fetchSection(sectionId);
    section.set(_resp.payload);
}
export async function fetchChallenge(challengeId) {
    let _resp = await ChallengeService.fetchChallenge(challengeId);
    challenge.set(_resp.payload);
}
// winning submissions...
export async function loadWinningSubmissions(challengeId) {
    loading.set(true);
    try {
        let _filter = ({ criteria: { challengeId: challengeId }, params: null, sorting: "-createdOn" });
        //let _pag = get(pagination);
        let _pag = { currentPage: 1, totalPages: 0, totalRecords: 0 };
        let _resp = await SubmissionService.getWinningSubmissions(_filter, _pag.currentPage);
        winning.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
// load submissions...
export async function loadUserSubmissions(challengeId) {
    loading.set(true);
    try {
        let userId = get(user).oid;
        let _filter = ({ criteria: { challengeId: challengeId, portalUserId: userId }, params: null, sorting: "-createdOn" });
        //let _pag = get(pagination);
        let _pag = { currentPage: 1, totalPages: 0, totalRecords: 0 };
        let _resp = await SubmissionService.getSubmissions(_filter, _pag.currentPage);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export async function reloadUserSubmissions() {
    await loadUserSubmissions(get(challenge).oid);
}
export async function submitSolution() {
    const challengeId = get(challenge).oid;
    let s = {
        oid: 0,
        clfCompilerId: get(compilerId),
        source: get(sourceCode),
        points: 0,
        evaluated: 0,
        compilation: 0,
        diagnostics: "",
        success: 0,
        portalUserId: get(user).oid,
        challengeId: challengeId,
        createdOn: new Date(),
        updatedOn: new Date()
    };
    //compilerId.set(0);
    sourceCode.set("");
    await SubmissionService.saveSubmission(s);
    await loadUserSubmissions(challengeId);
}
export async function editSubmissionCode(submissionId) {
    let _resp = await SubmissionService.fetchSubmission(submissionId);
    if (_resp) {
        sourceCode.set(_resp.payload.source);
    }
}
export async function loadMyDefaultCompiler() {
    try {
        let _resp = await SubmissionService.getMyDefaultCompiler();
        if (_resp.payload)
            compilerId.set(_resp.payload.oid);
    }
    catch (e) {
        // swallow
    }
}
